"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _LineString = _interopRequireDefault(require("./LineString.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _closest = require("./flat/closest.js");

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _simplify = require("./flat/simplify.js");

var _array = require("../array.js");

var _inflate = require("./flat/inflate.js");

var _interpolate = require("./flat/interpolate.js");

var _intersectsextent = require("./flat/intersectsextent.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/MultiLineString
 */


/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */
var MultiLineString =
/** @class */
function (_super) {
  __extends(MultiLineString, _super);
  /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `opt_layout` and `opt_ends` are also accepted.)
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @param {Array<number>} [opt_ends] Flat coordinate ends for internal use.
   */


  function MultiLineString(coordinates, opt_layout, opt_ends) {
    var _this = _super.call(this) || this;
    /**
     * @type {Array<number>}
     * @private
     */


    _this.ends_ = [];
    /**
     * @private
     * @type {number}
     */

    _this.maxDelta_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDeltaRevision_ = -1;

    if (Array.isArray(coordinates[0])) {
      _this.setCoordinates(
      /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
      coordinates, opt_layout);
    } else if (opt_layout !== undefined && opt_ends) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);

      _this.ends_ = opt_ends;
    } else {
      var layout = _this.getLayout();

      var lineStrings =
      /** @type {Array<LineString>} */
      coordinates;
      var flatCoordinates = [];
      var ends = [];

      for (var i = 0, ii = lineStrings.length; i < ii; ++i) {
        var lineString = lineStrings[i];

        if (i === 0) {
          layout = lineString.getLayout();
        }

        (0, _array.extend)(flatCoordinates, lineString.getFlatCoordinates());
        ends.push(flatCoordinates.length);
      }

      _this.setFlatCoordinates(layout, flatCoordinates);

      _this.ends_ = ends;
    }

    return _this;
  }
  /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */


  MultiLineString.prototype.appendLineString = function (lineString) {
    if (!this.flatCoordinates) {
      this.flatCoordinates = lineString.getFlatCoordinates().slice();
    } else {
      (0, _array.extend)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
    }

    this.ends_.push(this.flatCoordinates.length);
    this.changed();
  };
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   */


  MultiLineString.prototype.clone = function () {
    var multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
    multiLineString.applyProperties(this);
    return multiLineString;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  MultiLineString.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    if (this.maxDeltaRevision_ != this.getRevision()) {
      this.maxDelta_ = Math.sqrt((0, _closest.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
      this.maxDeltaRevision_ = this.getRevision();
    }

    return (0, _closest.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
  };
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `opt_interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `opt_interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [opt_interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */


  MultiLineString.prototype.getCoordinateAtM = function (m, opt_extrapolate, opt_interpolate) {
    if (this.layout != _GeometryLayout["default"].XYM && this.layout != _GeometryLayout["default"].XYZM || this.flatCoordinates.length === 0) {
      return null;
    }

    var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
    var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
    return (0, _interpolate.lineStringsCoordinateAtM)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
  };
  /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */


  MultiLineString.prototype.getCoordinates = function () {
    return (0, _inflate.inflateCoordinatesArray)(this.flatCoordinates, 0, this.ends_, this.stride);
  };
  /**
   * @return {Array<number>} Ends.
   */


  MultiLineString.prototype.getEnds = function () {
    return this.ends_;
  };
  /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */


  MultiLineString.prototype.getLineString = function (index) {
    if (index < 0 || this.ends_.length <= index) {
      return null;
    }

    return new _LineString["default"](this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
  };
  /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */


  MultiLineString.prototype.getLineStrings = function () {
    var flatCoordinates = this.flatCoordinates;
    var ends = this.ends_;
    var layout = this.layout;
    /** @type {Array<LineString>} */

    var lineStrings = [];
    var offset = 0;

    for (var i = 0, ii = ends.length; i < ii; ++i) {
      var end = ends[i];
      var lineString = new _LineString["default"](flatCoordinates.slice(offset, end), layout);
      lineStrings.push(lineString);
      offset = end;
    }

    return lineStrings;
  };
  /**
   * @return {Array<number>} Flat midpoints.
   */


  MultiLineString.prototype.getFlatMidpoints = function () {
    var midpoints = [];
    var flatCoordinates = this.flatCoordinates;
    var offset = 0;
    var ends = this.ends_;
    var stride = this.stride;

    for (var i = 0, ii = ends.length; i < ii; ++i) {
      var end = ends[i];
      var midpoint = (0, _interpolate.interpolatePoint)(flatCoordinates, offset, end, stride, 0.5);
      (0, _array.extend)(midpoints, midpoint);
      offset = end;
    }

    return midpoints;
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   */


  MultiLineString.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    var simplifiedFlatCoordinates = [];
    var simplifiedEnds = [];
    simplifiedFlatCoordinates.length = (0, _simplify.douglasPeuckerArray)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
    return new MultiLineString(simplifiedFlatCoordinates, _GeometryLayout["default"].XY, simplifiedEnds);
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  MultiLineString.prototype.getType = function () {
    return _GeometryType["default"].MULTI_LINE_STRING;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  MultiLineString.prototype.intersectsExtent = function (extent) {
    return (0, _intersectsextent.intersectsLineStringArray)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
  };
  /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {GeometryLayout} [opt_layout] Layout.
   * @api
   */


  MultiLineString.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 2);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    var ends = (0, _deflate.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
    this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
    this.changed();
  };

  return MultiLineString;
}(_SimpleGeometry["default"]);

var _default = MultiLineString;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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